import { ApiPaginatedRequest } from './api-paginated-request';
import { ApiRequestOrdering } from './api-request-ordering';

/**
 * Api ordered paginated request
 */
export class ApiOrderedPaginatedRequest extends ApiPaginatedRequest {
	ordering?: ApiRequestOrdering;
}
